/**
 * Event tags reducer
 * Learns of all existing tags and stores them, minus the counts as those are dependent on the endpoint used
 */

import { produce } from 'immer';

const DEFAULT_STATE = [];

export default function tagsReducer(state, action) {
    if (!state) {
        state = [];
    }

    switch (action.type) {
        // Learn tags from exhibitors
        case 'EVENT_EXHIBITORS_SET_FILTER_PARAMS':
        case 'UPDATE_DIRECTORY_TAGS':
            state = updateTagsState(state, action.tags);
            break;
    }

    return state;
}

function updateTagsState(state, tags) {
    return produce(state, (draft) => {
        for (let group of tags) {
            let index = state.findIndex((tag) => tag.name == group.name);
            if (index < 0) {
                index = state.length;
                draft[index] = {
                    name: group.name,
                    options: [],
                };
            }

            draft[index].order = group.order;

            for (let option of group.options) {
                let optionIndex = draft[index].options.findIndex((o) => o.name == option.name);
                if (optionIndex < 0) {
                    optionIndex = draft[index].options.length;
                    draft[index].options[optionIndex] = {
                        name: option.name,
                        color: option.color,
                        order: option.order,
                    };
                }
            }
        }
    });
}
